import {
  Wallet,
  Home,
  Car,
  Lightbulb,
  Smartphone,
  CreditCard,
  Landmark,
  FileText,
  Package,
  Users,
  RefreshCw,
  ShoppingCart,
  Bus,
  Shield,
  Coffee,
  ShoppingBag,
  Heart,
  Film,
  Plane,
  HelpCircle,
  LucideIcon,
  CircleDollarSign,
  Briefcase,
  Building2,
  Banknote,
  Receipt,
  Truck,
  Wrench,
  Wifi,
  Zap,
  Fuel,
  PiggyBank,
  TrendingUp,
  Tag
} from 'lucide-react'

// Map icon names to Lucide components
const iconMap: Record<string, LucideIcon> = {
  // Default categories
  Wallet,
  Home,
  Car,
  Lightbulb,
  Smartphone,
  CreditCard,
  Landmark,
  FileText,
  Package,
  Users,
  RefreshCw,
  ShoppingCart,
  Bus,
  Shield,
  Coffee,
  ShoppingBag,
  Heart,
  Film,
  Plane,
  HelpCircle,
  // Additional icons for custom categories
  CircleDollarSign,
  Briefcase,
  Building2,
  Banknote,
  Receipt,
  Truck,
  Wrench,
  Wifi,
  Zap,
  Fuel,
  PiggyBank,
  TrendingUp,
  Tag
}

// Get available icon names
const getAvailableIcons = () => Object.keys(iconMap)

interface CategoryIconProps {
  icon?: string
  className?: string
  style?: React.CSSProperties
  size?: 'sm' | 'md' | 'lg'
}

const sizeMap = {
  sm: 'w-4 h-4',
  md: 'w-5 h-5',
  lg: 'w-6 h-6'
}

export default function CategoryIcon({ icon, className, style, size = 'md' }: CategoryIconProps) {
  const sizeClass = className || sizeMap[size]
  
  // Check if it's an emoji (legacy support)
  if (icon && icon.length <= 2 && /\p{Emoji}/u.test(icon)) {
    return <span className={sizeClass} style={style}>{icon}</span>
  }

  // Get Lucide icon component
  const IconComponent = iconMap[icon || ''] || HelpCircle

  return <IconComponent className={sizeClass} style={style} />
}

// Icon picker component for category creation/editing
export function IconPicker({ 
  selectedIcon, 
  onSelect,
  color = '#64748b'
}: { 
  selectedIcon: string
  onSelect: (icon: string) => void
  color?: string
}) {
  const availableIcons = getAvailableIcons()
  return (
    <div className="grid grid-cols-5 sm:grid-cols-6 gap-2">
      {availableIcons.map((iconName) => {
        const IconComponent = iconMap[iconName]
        const isSelected = selectedIcon === iconName
        return (
          <button
            key={iconName}
            type="button"
            onClick={() => onSelect(iconName)}
            className={`p-2 rounded-lg border-2 transition-all ${
              isSelected 
                ? 'border-primary-500 bg-primary-50 dark:bg-primary-900/30' 
                : 'border-gray-200 dark:border-slate-600 hover:border-gray-300 dark:hover:border-slate-500'
            }`}
          >
            <IconComponent 
              className="w-5 h-5 mx-auto" 
              style={{ color: isSelected ? color : undefined }}
            />
          </button>
        )
      })}
    </div>
  )
}
